import React from 'react';

const Success = () => {
    return (
        <div id='success-container'>
            <div className="brand-logo">
                <h1>
                    <span>B</span>k-
                    <span>E</span>lite.
                </h1>
            </div>
            <div className="success-txt">
                <h2>Merci pour votre réservation !</h2>
                <p>Nous reviendrons vers vous dans les meilleurs délais.</p>
            </div>
        </div>
    );
};

export default Success;